import { render, staticRenderFns } from "./NotificationManage.vue?vue&type=template&id=4422ec04&scoped=true"
import script from "./NotificationManage.vue?vue&type=script&lang=js"
export * from "./NotificationManage.vue?vue&type=script&lang=js"
import style0 from "./NotificationManage.vue?vue&type=style&index=0&id=4422ec04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4422ec04",
  null
  
)

export default component.exports